export default __webpack_public_path__ + "static/media/srdicko.d02f079e.jpg";